export default "/images/vendor/flag-icons/flags/1x1/kp.svg?650f6d2f12e900e69c1074f7e3f4472d";